import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import useTriggerRMFFlow from '../../../hooks/useTriggerRMFFlow';
import { CashierFlowType } from '../../../types/Cashier';
import Prompt from '../../Prompt/Prompt';

import {
  TXTWCL_Before_you_can_depositX_we_nee_ELL_2,
  TXTWCL_Before_you_can_withdrawX_we_ne_ELL,
  TXTWCL_Continue,
  TXTWCL_Just_a_moment_1
} from './RMFRequired.messages.json';
import { messageText } from './RMFRequired.scss';

interface Props {
  onClose(): void;
}

const RMFRequired: React.FC<Props> = ({ onClose }) => {
  const {
    data: { cashierFlow }
  } = useWizardContext();
  const isDepositFlow = cashierFlow === CashierFlowType.FirstDeposit;
  const jumpToRmf = useTriggerRMFFlow();
  const target = isDepositFlow ? '#deposit.deposit-process' : '#withdraw.get-cashout-options';
  const triggerPoint = isDepositFlow ? 'deposit' : 'withdrawal';

  return (
    <Prompt
      onClose={onClose}
      variant="info"
      title={{ translation: TXTWCL_Just_a_moment_1 }}
      primaryButton={{
        translation: TXTWCL_Continue
      }}
      onPrimaryButtonClick={() => jumpToRmf(target, triggerPoint)}
    >
      <div className={messageText}>
        {isDepositFlow ? (
          <Translation {...TXTWCL_Before_you_can_depositX_we_nee_ELL_2} />
        ) : (
          <Translation {...TXTWCL_Before_you_can_withdrawX_we_ne_ELL} />
        )}
      </div>
    </Prompt>
  );
};

export default RMFRequired;
